import { render, staticRenderFns } from "./gpsDiag.vue?vue&type=template&id=b8e8f904&scoped=true"
import script from "./gpsDiag.vue?vue&type=script&lang=js"
export * from "./gpsDiag.vue?vue&type=script&lang=js"
import style0 from "./gpsDiag.vue?vue&type=style&index=0&id=b8e8f904&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e8f904",
  null
  
)

export default component.exports